export const BRAND = {
  name: "Medical Arts Groves Inc",
  shortName: "Medical Arts Groves",
  domain: "medicalartsgrove.online",
  tagline: "Luxury Aesthetic Surgery & Recovery",
  npi: "1770495293",
  npiUrl: "https://npiregistry.cms.hhs.gov/provider-view/1770495293",
  phone: "844.943.6281",
  phoneHref: "8449436281",
  email: "info@medicalartsgrove.online",
  offices: [
    {
      label: "Main Office",
      line1: "1000 Social St, Ste 1280",
      line2: "Raleigh, NC 27609",
    },
    {
      label: "Headquarters",
      line1: "234 E 1st St, Ste 030",
      line2: "Casper, WY 82601",
    },
  ],
  hours: [
    { days: "Monday – Friday", time: "9:00 AM – 5:00 PM" },
    { days: "Saturday – Sunday", time: "11:00 AM – 4:00 PM" },
  ],
};

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Recovery", path: "/recovery" },
  { label: "Gallery", path: "/gallery" },
  { label: "Consultations", path: "/consultations" },
  { label: "Contact", path: "/contact" },
];

export const IMAGES = {
  heroHome:
    "https://images.unsplash.com/photo-1508153460964-48ffffcb0829?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxiZWF1dHklMjBzaWxob3VldHRlJTIwd29tYW58ZW58MHx8fHwxNzgyMTMyMzczfDA&ixlib=rb-4.1.0&q=85",
  recovery:
    "https://images.pexels.com/photos/6628520/pexels-photo-6628520.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  abstractGold:
    "https://images.pexels.com/photos/21033071/pexels-photo-21033071.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  floral:
    "https://images.pexels.com/photos/9376941/pexels-photo-9376941.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  gallerySilhouette:
    "https://images.pexels.com/photos/8964911/pexels-photo-8964911.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
